import { createContext, useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Loader from "./Component/Loader/Loader";
import ErrorPage from "./Component/Main/ErrorPage";
import AddReview from "./Component/Reviews/AddReview";
import AllReviews from "./Component/Reviews/AllReviews";
import PerticularReviews from "./Component/Reviews/PerticularReviews";
import ProductReview from "./Component/Reviews/ProductReview";
import { clientData, GetClient } from "./controllers/GetClient";
import SaveChangesPopup from "./controllers/SaveChangesPopup";
import API from "./API/newIndex";
import { LastRouteProvider } from "./controllers/LastRouteContext";
import { RichTextProvider } from "./Component/custom-texteditor/RichTextContext";
import { TableColumnsContext } from "./controllers/TableColumnsContext";
import { UserProvider, UserContext } from "./controllers/UserContext";

export { TableColumnsContext, UserContext };
export const ChangePathContext = createContext();
export const PlanPermission = createContext();
export const DataLoad = createContext();
export const SelectSection = createContext();
export const Extention = createContext();
export const StoreDeletePending = createContext();

const App = () => {
  let token = localStorage.getItem("token");
  const clientInfo = clientData;
  const [installedExtensions, setInstalledExtensions] = useState([]);
  const [planActive, setPlanActive] = useState(false);
  const [isIncluded, setIsIncluded] = useState(true);
  const [spinner, setSpinner] = useState(token && !isIncluded ? true : false);
  const [Permissions, setPermissions] = useState();
  const [announcement, setAnnouncement] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [AnnData, setAnnData] = useState();
  const [accessDenied, setAccessDenied] = useState(false);
  const [tokenReady, setTokenReady] = useState(!!localStorage.getItem("token"));
  const [tableColumnsData, setTableColumnsData] = useState(null);
  const tableColumnsDataRef = useRef(null);
  const isFetchingTableColumns = useRef(false);

  let business_name = localStorage.getItem("business_name");
  const navigate = useNavigate();
  const searchPath = useLocation();

  const installExtentionName =
    installedExtensions?.length > 0 ? installedExtensions?.map((x) => x?.super_extension_id) : [];

  const subscrptionLine =
    (planActive && clientInfo?.billing_detail?.next_billing_date && token && !isIncluded) ||
    (planActive && clientInfo?.billing_detail?.plan_type === "Free" && !isIncluded);
  const [saveChanges, setSaveChanges] = useState({
    isUnsaveChanges: false,
    showChangesPopup: false,
    backLink: "",
    title: "",
  });
  const [planPermission, setPlanPermission] = useState({
    isPlanPermissions: true,
    forModule: null,
  });
  const [dataLoading, setDataLoading] = useState(false);
  const getTableColumns = async (force = false) => {
    if (!force && (tableColumnsDataRef.current || tableColumnsData)) {
      return tableColumnsDataRef.current || tableColumnsData;
    }
    if (isFetchingTableColumns.current) return;

    isFetchingTableColumns.current = true;
    try {
      const res = await API({ url: "/admin/product/getTableColumns", method: "get" });
      if (res?.data) {
        tableColumnsDataRef.current = res.data;
        setTableColumnsData(res.data);
        return res.data;
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      isFetchingTableColumns.current = false;
    }
  };

  const GetInstalledExtensions = async () => {
    try {
      const ApiCall = await API({
        url: `/admin/extension/GetInstalledExtensions`,
        method: "get",
      });
      if (ApiCall.data) {
        const result = ApiCall?.data;
        setInstalledExtensions(result?.data);
        return result?.data;
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const GetUserPermissions = async () => {
    try {
      let ApiCall = await API({ url: "/admin/role/getLoginUserRole", method: "get" });
      const result = ApiCall?.data;
      setPermissions(result);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const GetAnnouncemnet = async () => {
    try {
      let ApiCall = await API({
        url: `/admin/announcement/UserGetAnnouncements?type=1&limit=3&page=1`,
        method: "get",
      });
      if (ApiCall?.data) {
        const result = ApiCall?.data;
        setAnnouncement(true);
        setAnnData(result);
      } else {
        setAnnouncement(false);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const CheckPlanStatus = async () => {
    if (business_name?.length > 0) {
      setSpinner(true);
      try {
        await API({ url: `/admin/plan/planStatusCheck`, method: "get" });
        setPlanActive(true);
        await GetInstalledExtensions();
        await GetUserPermissions();
        await GetAnnouncemnet();
      } catch (error) {
        if (error?.response?.status === 498) {
          setPlanActive(false);
        } else {
          setIsNotification(true);
          setNotificationMsg(error);
          setSeverity("error");
        }
      } finally {
        setSpinner(false);
      }
    } else {
      setPlanActive(false);
    }
  };

  useEffect(() => {
    // Initial dark mode application
    const savedDarkMode = localStorage.getItem("dark-mode");
    if (savedDarkMode === "true" || savedDarkMode === true) {
      document.documentElement.classList.add("dark-mode");
    } else {
      document.documentElement.classList.remove("dark-mode");
    }

    if (window.self === window.top) {
      setAccessDenied(true);
      return;
    }

    if (!document.referrer || !document.referrer.startsWith(process.env.REACT_APP_ADMIN_URL)) {
      setAccessDenied(true);
      return;
    }

    window.addEventListener("message", (event) => {
      if (event.origin === process.env.REACT_APP_ADMIN_URL) {
        const data = event.data;
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            localStorage.setItem(key, data[key]);
          }
        }

        if (data.token) {
          setTokenReady(true);
        }

        if (data?.type === "NAVIGATE_IFRAME_INTERNAL" && typeof data.path === "string") {
          navigate(data.path);
        }

        if (data?.type === "DARK_MODE_CHANGE" || data?.type === "INIT_IFRAME") {
          const isDarkMode =
            data?.type === "DARK_MODE_CHANGE"
              ? data["dark-mode"]
              : data["dark-mode"] === "true" || data["dark-mode"] === true;
          console.log(isDarkMode, "isDarkMode");
          localStorage.setItem("dark-mode", isDarkMode);
          if (isDarkMode) {
            document.documentElement.classList.add("dark-mode");
          } else {
            document.documentElement.classList.remove("dark-mode");
          }
        }
      } else {
        console.warn("Message origin not trusted:", event.origin);
      }
    });
  }, []);

  useEffect(() => {
    if (!tokenReady) return;
    GetInstalledExtensions();
    CheckPlanStatus();
    GetClient();
    getTableColumns();
  }, [tokenReady]);
  return (
    <UserProvider tokenReady={tokenReady}>
      <TableColumnsContext.Provider value={{ tableColumnsData, setTableColumnsData, getTableColumns }}>
        <LastRouteProvider>
          <ChangePathContext.Provider value={{ saveChanges, setSaveChanges }}>
            <PlanPermission.Provider value={{ planPermission, setPlanPermission }}>
              <DataLoad.Provider value={{ dataLoading, setDataLoading }}>
                <SaveChangesPopup />
                <RichTextProvider>
                  {/* Product Subscription */}
                  <Routes>
                    {/* Reviews And GDPR */}
                    {installExtentionName?.length > 0 && installExtentionName?.includes("6683ed80529fd09fc74be6c7") && (
                      <>
                        <Route
                          path="/reviews"
                          element={
                            planActive && !Permissions?.data?.permissions && spinner ? (
                              <div className="absolute-loader">
                                <Loader />
                              </div>
                            ) : Permissions?.data?.permissions?.includes("get_AllReviews") ||
                              Permissions?.data?.permissions === "all" ? (
                              <AllReviews
                                permissionCheck={
                                  Permissions?.data?.permissions?.includes("add_Reviews") ||
                                  Permissions?.data?.permissions === "all"
                                }
                              />
                            ) : (
                              <></>
                            )
                          }
                        />
                        <Route path="/reviews/add" element={planActive && <AddReview />} />
                        <Route
                          path="/reviews/setting"
                          element={
                            planActive && !Permissions?.data?.permissions && spinner ? (
                              <div className="absolute-loader">
                                <Loader />
                              </div>
                            ) : Permissions?.data?.permissions?.includes("get_AllReviews") ||
                              Permissions?.data?.permissions === "all" ? (
                              <ProductReview />
                            ) : (
                              <></>
                            )
                          }
                        />
                        <Route
                          path="/reviews/:reviews_id"
                          element={
                            planActive && !Permissions?.data?.permissions && spinner ? (
                              <div className="absolute-loader">
                                <Loader />
                              </div>
                            ) : Permissions?.data?.permissions?.includes("get_ProductReviews") ||
                              Permissions?.data?.permissions === "all" ? (
                              <PerticularReviews />
                            ) : (
                              <></>
                            )
                          }
                        />
                      </>
                    )}
                    <Route path="/*" element={planActive || (accessDenied && <ErrorPage />)} />
                  </Routes>
                </RichTextProvider>
              </DataLoad.Provider>
            </PlanPermission.Provider>
          </ChangePathContext.Provider>
        </LastRouteProvider>
      </TableColumnsContext.Provider>
    </UserProvider>
  );
};

export default App;
